module.exports = __webpack_public_path__ + "static/img/life-style7.c81efd10.png";